import { put, takeEvery, select, getContext } from 'redux-saga/effects';
import {
  acceptCallByRemote,
  startCallByRemote,
  rejectCallByRemote,
  cancelCallByRemote,
  endCallByRemote,
  toggleRemoteMic,
  toggleRemoteCamera,
  toggleRemoteScreenSharing,
  changeRemoteCameraFacingMode,
  sendViewerSettingsByRemote,
} from './actions';
import { SOCKET_EVENT } from '../communication/actions';
import authSelectors from '../auth/selectors';
import communicationSelectors from '../communication/selectors';
import { getLogger } from '../../logger/index';

const logger = getLogger('communicationVideo');

function* onEventFromRemote({ payload: { eventName, args } }) {
  const isMobile = yield getContext('isMobile');

  try {
    const socketEventToActionMap = {
      ...(isMobile
        ? {}
        : {
            videocall_ring: from => startCallByRemote(from, 'video'),
            call_ring: from => startCallByRemote(from, 'audio'),
          }),
      send_viewer_settings: () => sendViewerSettingsByRemote({ settings: args }),
      videocall_accepted: from => acceptCallByRemote(from),
      call_accepted: from => acceptCallByRemote(from),
      videocall_rejected: (from, payload) => rejectCallByRemote(from, payload.reason),
      call_rejected: (from, payload) => rejectCallByRemote(from, payload.reason),
      videocall_cancelled: (from, payload) => cancelCallByRemote(from, payload.reason),
      call_cancelled: (from, payload) => cancelCallByRemote(from, payload.reason),
      videocall_ended: from => endCallByRemote(from),
      call_ended: from => endCallByRemote(from),
      microphone_muted: from => toggleRemoteMic(from, false),
      microphone_unmuted: from => toggleRemoteMic(from, true),
      camera_deactivated: from => toggleRemoteCamera(from, false),
      camera_activated: from => toggleRemoteCamera(from, true),
      desktop_sharing_deactivated: from => toggleRemoteScreenSharing(from, false),
      desktop_sharing_activated: from => toggleRemoteScreenSharing(from, true),
      change_camera_facing_mode: from => changeRemoteCameraFacingMode(from, args.facingMode),
    };
    if (Object.keys(socketEventToActionMap).includes(eventName)) {
      const authId = yield select(authSelectors.getId);
      const isAnonymous = yield select(communicationSelectors.isAnonymous);
      const from =
        args.from === authId || isAnonymous
          ? { id: args.to || args.ender, name: args.toName, role: args.role }
          : { id: args.from, name: args.fromName, role: args.role };

      logger.debug('Trigger remote action on socket event:', eventName);

      yield put(socketEventToActionMap[eventName](from, args));
    }
  } catch (e) {
    logger.error(e);
  }
}

export default function* watchSocketEventActions() {
  logger.debug('Watch socket events');
  yield takeEvery(SOCKET_EVENT, onEventFromRemote);
}
